// extracted by mini-css-extract-plugin
module.exports = {"root":"GalleryBlock_root__ENXuO"};